import { AxiosResponse } from 'axios';
import { SET_RECENT_PHOTOS, SET_RECENT_PHOTO, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_RECENT_PHOTO_ISLOADING,
  DELETE_RECENT_PHOTO,
  EDIT_RECENT_PHOTO,
  GET_RECENT_PHOTO,
  GET_RECENT_PHOTOS,
  REGISTER_RECENT_PHOTO,
  TOGGLE_RECENT_PHOTO_IS_ACTIVE,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import RecentPhoto from '@/services/recent_photo';
import { Module } from 'vuex';
import { EditRecentPhoto, RegisterRecentPhoto, GetRecentPhoto } from '@/dtos/recent_photo.dto';

const recentPhoto: Module<any, {}> = {
  state: {
    recentPhoto: {
      data: null,
      isLoading: false,
    },
    recentPhotos: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    recentPhoto: (state: { recentPhoto: any }) => state.recentPhoto,
    recentPhotos: (state: { recentPhotos: any }) => state.recentPhotos,
  },
  mutations: {
    [SET_RECENT_PHOTO]: (
      state: { recentPhoto: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.recentPhoto.data = payload.data) : null,
        (state.recentPhoto.isLoading = payload.isLoading);
    },
    [SET_RECENT_PHOTOS]: (
      state: { recentPhotos: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.recentPhotos.data = payload.data) : null,
        (state.recentPhotos.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_RECENT_PHOTO]: async ({ commit }: any, payload: FormData) => {
      commit(SET_RECENT_PHOTO, { data: null, isLoading: true });

      const result: AxiosResponse = await RecentPhoto.registerRecentPhoto(
        payload
      );

      if (result) {
        if (result.data.status) {
          commit(SET_RECENT_PHOTO, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_RECENT_PHOTO, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_RECENT_PHOTO, { isLoading: false });
        return false;
      }
    },
    [GET_RECENT_PHOTOS]: async ({ commit }: any, payload: any) => {
      commit(SET_RECENT_PHOTOS, { data: null, isLoading: true });

      const result: AxiosResponse = await RecentPhoto.getRecentPhotos(
        payload as GetRecentPhoto
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_RECENT_PHOTOS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_RECENT_PHOTOS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_RECENT_PHOTOS, { isLoading: false });
        return false;
      }
    },
    [GET_RECENT_PHOTO]: async ({ commit }: any, payload: any) => {
      commit(SET_RECENT_PHOTO, { data: null, isLoading: true });

      const result: AxiosResponse = await RecentPhoto.getRecentPhotos(
        payload as GetRecentPhoto
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_RECENT_PHOTO, { data: result.data.data[0], isLoading: false });
          return true;
        }
        commit(SET_RECENT_PHOTO, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_RECENT_PHOTO, { isLoading: false });
        return false;
      }
    },
    [EDIT_RECENT_PHOTO]: async ({ commit }: any, payload: FormData) => {
      commit(SET_RECENT_PHOTO, { data: null, isLoading: true });

      const result: AxiosResponse = await RecentPhoto.editRecentPhoto(
        payload
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_RECENT_PHOTO, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_RECENT_PHOTO, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_RECENT_PHOTO, { isLoading: false });
        return false;
      }
    },
    [TOGGLE_RECENT_PHOTO_IS_ACTIVE]: async ({ commit, state }: any, payload: EditRecentPhoto) => {
      commit(SET_RECENT_PHOTO, { data: { id: payload.id }, isLoading: true });

      const result: AxiosResponse = await RecentPhoto.toggleRecentPhotoIsActive(
        payload
      );

      if (result) {
        if (result.data.status) {
          let index;
          if (state.recentPhotos.data) {
            state.recentPhotos.data.forEach((e: any, i: number) => {
              if (e.id == result.data.data.id) {
                index = i;
              }
            });
            if (index != null)
              state.recentPhotos.data[index].isActive = result.data.data.isActive;
          }
          console.log('result.data.data', result.data.data);
          commit(SET_RECENT_PHOTO, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_RECENT_PHOTO, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_RECENT_PHOTO, { isLoading: false });
        return false;
      }
    },
    [DELETE_RECENT_PHOTO]: async ({ commit }: any, payload: string) => {
      commit(SET_RECENT_PHOTO, { data: null, isLoading: true });

      const result: AxiosResponse = await RecentPhoto.deleteRecentPhoto(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_RECENT_PHOTO, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_RECENT_PHOTO, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_RECENT_PHOTO, { isLoading: false });
        return false;
      }
    },
    [CLEAR_RECENT_PHOTO_ISLOADING]: ({ commit }) => {
      commit(SET_RECENT_PHOTO, { isLoading: false });
      commit(SET_RECENT_PHOTOS, { isLoading: false });
    },
  },
};

export default recentPhoto;
